import { GridElement } from '..'
import { TextColumn } from '../../components'
import { TextColumnPropsApi } from '../../components/textColumn/models'

import './three-column-text.scss'

export interface PagePromotionProps extends GridElement {
    value: {
        columnOne: TextColumnPropsApi
        columnTwo: TextColumnPropsApi
        columnThree: TextColumnPropsApi
    }
}

export const ThreeColumnText: React.FC<PagePromotionProps> = props => {
    return (
        <div className="three-column-text bottom-spacing">
            <TextColumn {...props.value.columnOne}></TextColumn>
            <TextColumn {...props.value.columnTwo}></TextColumn>
            <TextColumn {...props.value.columnThree}></TextColumn>
        </div>
    )
}
